export default "__VITE_ASSET__CpStls4M__"